/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, breakAnywhere, sticky, children }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      // 16px sides below 1400px so 8-9 column tables fit a laptop-width card; 24px on wide screens.
      px={{ xs: 2, xxl: 3 }}
      sx={({
        palette: { light, white, background },
        typography: { size },
        borders: { borderWidth },
      }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        ...(sticky
          ? {
              // Pinned to the card's right edge while the table scrolls sideways.
              position: "sticky",
              right: 0,
              zIndex: 1,
              backgroundColor: background.card || white.main,
              boxShadow: "-8px 0 8px -8px rgba(0, 0, 0, 0.25)",
            }
          : {}),
      })}
    >
      {/* Was width="max-content", so no cell ever wrapped: one long email or description
          widened its whole column and pushed every table past its card (the actions column
          ended up off-screen). Cells now wrap between words; phone numbers, dates and amounts
          stay whole. Email-like columns (breakAnywhere) may also break inside the address,
          since one long address would otherwise set its column's width on its own. */}
      <MDBox
        display="inline-block"
        maxWidth="100%"
        color="text"
        sx={{
          verticalAlign: "middle",
          ...(breakAnywhere
            ? { overflowWrap: "anywhere", minWidth: "8rem" }
            : { overflowWrap: "break-word" }),
        }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  breakAnywhere: false,
  sticky: false,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  breakAnywhere: PropTypes.bool,
  sticky: PropTypes.bool,
};

export default DataTableBodyCell;
